import { render } from "./LogoCarousel.vue?vue&type=template&id=48deb6c4"
import script from "./LogoCarousel.vue?vue&type=script&lang=js"
export * from "./LogoCarousel.vue?vue&type=script&lang=js"

import "./LogoCarousel.vue?vue&type=style&index=0&id=48deb6c4&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__